import type { StorageDashboardSummary } from './storageDashboardTypes';
import {
  displayStorageActivityOperation,
  displayStorageFileName,
  formatStorageDashboardRelativeTime
} from './storageDashboardFormatters';

export function StorageRecentActivityCard({ summary }: { summary: StorageDashboardSummary }) {
  const activity = summary.activityLast7Days;

  return (
    <section className="dashboard-card dashboard-card--storage">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">Recent Activity</h3>
          <p>File changes in the last seven days</p>
        </div>
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{activity.totalChanges}</span>
          <span className="dashboard-kpi__label">Total changes</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{activity.uploads}</span>
          <span className="dashboard-kpi__label">Uploads</span>
        </div>
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{activity.renames}</span>
          <span className="dashboard-kpi__label">Renames</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{activity.deletes}</span>
          <span className="dashboard-kpi__label">Deletes</span>
        </div>
      </div>

      <div className="dashboard-card__section">
        <h4 className="dashboard-card__section-title">Latest Changes</h4>
        {summary.recentActivity.length === 0 ? (
          <p className="dashboard-empty">No file activity in the last seven days.</p>
        ) : (
          <ul className="dashboard-upcoming-list">
            {summary.recentActivity.map((item) => (
              <li key={item.id}>
                <span>
                  <strong>{displayStorageFileName(item.path)}</strong>
                  <small>
                    {displayStorageActivityOperation(item.operation)} · {item.mountDisplayName}
                    {item.userName ? ` · ${item.userName}` : ''}
                  </small>
                </span>
                <span>{formatStorageDashboardRelativeTime(item.occurredAt)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
